import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
import { CTABannerSection } from '../components/CTABannerSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-984">
      <Navbar data-id="element-985" />
      <main data-id="element-986">
        <HeroSection data-id="element-987" />
        <ValuePropsSection data-id="element-988" />
        <ServicesSection data-id="element-989" />
        <WhyChooseUsSection data-id="element-990" />
        <TestimonialsSection data-id="element-991" />
        <PricingSection data-id="element-992" />
        <ServiceAreaSection data-id="element-993" />
        <FAQSection data-id="element-994" />
        <CTABannerSection data-id="element-995" />
      </main>
      <Footer data-id="element-996" />
    </div>;
}